import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  FormFieldConfig,
  formTemplateGenericSort,
  QuestionGroupConfig
} from './../../../form-template-model';
import { FormTemplateGeneratorService } from './../../form-template-generator.service';

@Component({
  selector: 'csi-form-template-question-group-field-generator',
  templateUrl: './form-template-question-group-field-generator.component.html',
  styleUrls: ['./form-template-question-group-field-generator.component.css']
})
export class FormTemplateQuestionGroupFieldGeneratorComponent implements OnInit {
  @Input() config: FormFieldConfig & { typeConfig: QuestionGroupConfig };
  @Input() formTemplateFieldKey: string;
  @Input() formTemplateGroupFormGroup: FormGroup;
  @Input() readOnly: boolean;
  @Input() formatForPDF: boolean;
  @Input() supportingFields: { [key: string]: FormFieldConfig };

  sortValues = formTemplateGenericSort;
  constructor(public formTemplateGeneratorService: FormTemplateGeneratorService) {}

  ngOnInit() {
    // console.log(this.formTemplateFieldKey, this.formTemplateGroupFormGroup.valueChanges);
    // console.log(this.config);
  }
}
